import { EnquiryURL } from "./APIUrls";

const InsertNewEnquiry = async (enquiryData) => {
    try {
        const response = await fetch(`${EnquiryURL}InsertEnquiry`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(enquiryData),
        });

        const data = await response.json();

        if (response.ok && data.Message == "Success") {
            return {
                status: response.status,
                data: data.data,
                returnID: data.returnID,
                success: true,
                message: data.Message || "Success",
            };
        }

        return {
            status: response.status,
            data: null,
            returnID: null,
            success: false,
            message: data?.Message || "Failed",
        };
    } catch (error) {
        return {
            status: 500,
            data: null,
            returnID: null,
            success: false,
            message: error.message,
        };
    }
};

const GetEnquiryByVendorId = async (vendorId, token) => {
    try {
        const response = await fetch(`${EnquiryURL}GetEnquiryByVendorId/${vendorId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({}),
        });

        const text = await response.text();
        if (!text || text.trim() === "") {
            return {
                status: response.status,
                data: [],
                success: false,
                message: "Server returned an empty response",
            };
        }

        const data = JSON.parse(text);

        return {
            status: response.status,
            data: data?.data || data?.Data || (Array.isArray(data) ? data : []),
            success: response.ok,
            message: data?.Message || data?.message || "Success",
        };
    } catch (error) {
        return {
            status: 500,
            data: [],
            success: false,
            message: error.message,
        };
    }
};

const UpdateIsReadVendorEnquiry = async (id, value, token) => {
    try {
        const response = await fetch(`${EnquiryURL}UpdateIsReadVendorEnquiry/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify({ Value: value }),
        });

        const text = await response.text();
        if (!text || text.trim() === "") {
            return {
                status: response.status,
                success: response.ok,
                message: "Server returned an empty response",
                data: null,
            };
        }

        const data = JSON.parse(text);

        return {
            status: response.status,
            success: response.ok,
            message: data?.Message || data?.message || "Success",
            data,
        };
    } catch (error) {
        return {
            status: 500,
            success: false,
            message: error.message,
            data: null,
        };
    }
};

export { InsertNewEnquiry, GetEnquiryByVendorId, UpdateIsReadVendorEnquiry };
